import React from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import JobCard from "./_components/JobCard";
import "./JobBoardExpanded.scss";
import useJobBoardExpanded from "./useJobBoardExpanded";
import { Pagination } from "antd";
import JobDetailsCard from "./_components/JobDetailsCard";
import CandidateJobApply from "./_components/CandidateJobApply";
import MentorJobApply from "./_components/MentorJobApply";
import JobSearch from "./_components/JobSearch";
import MainLayout from "../MainLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faArrowLeft } from "@fortawesome/free-solid-svg-icons";

function JobListingExpanded(props) {
  const {
    allJobs,
    loading,
    jobDetails,
    jobDetailsLoading,
    jobApplyLoading,
    formSubmitError,
    currentPage,
    userInfo,
    fieldsShown,
    formData,
    jobCardDivParentRef,
    userMetaData,
    jobSearch,
    jobLoading,
    showSearch,
    jobApplyModal,
    isResumeLoading,
    isPrfoileUpdateLoading,
    onCurrentJobCardChange,
    onCurrentPageChange,
    handleClose,
    onProfileUpdate,
    onFormDataChange,
    onSubmitForm,
    onCoverLetterUpload,
    onViewCompany,
    onJobCardClick,
    onResumeUpload,
    editResumeClicked,
    onResumeEditClick,
    onApplyClick,
    onBackClick
  } = useJobBoardExpanded(props);


  return (
    <MainLayout pageName={"Job Board"}>
      <div className="job-board-expanded-wrapper pl-3">
        <Container>
          <div className="job-board-expanded footer-gap">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center w-100">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <>
                <div
                  className="row no-gutters
                   align-items-center  mx-0 my-2"
                >
                  <div className="m-n3">
                  <FontAwesomeIcon icon={faAngleLeft} onClick={onBackClick} className="mr-2 font-weight-medium" />
                    {showSearch ? (
                      <h2 className="d-inline-block mb-4 py-2">
                        Showing {jobSearch && jobSearch.length} Result
                      </h2>
                    ) : (
                      <h2 className="d-inline-block mb-4 py-2">
                        Showing {Array.isArray(allJobs) && allJobs.length} Jobs
                      </h2>
                    )}
                  </div>
                </div>

                {showSearch ? (
                  <JobSearch
                    jobSearch={jobSearch}
                    jobLoading={jobLoading}
                    onJobApplyClick={onSubmitForm}
                    handleClose={handleClose}
                    onViewCompany={onViewCompany}
                    formSubmitError={formSubmitError}
                    onJobCardClick={onCurrentJobCardChange}
                    activeJobCard={jobCardDivParentRef}
                    currentPage={currentPage}
                    jobDetailsLoading={jobDetailsLoading}
                  />
                ) : (
                  <Row>
                    <Col lg={5} xl={4} className=" px-0">
                      <div className="job-cards-list pr-0 pr-lg-3" ref={jobCardDivParentRef}>
                        {Array.isArray(allJobs) &&
                          allJobs.map((item, index) => (
                            <div key={item?.id}>
                              <JobCard
                                jobDetail={item}
                                onJobCardClick={onCurrentJobCardChange}
                                activeJobCard={jobDetails.id === item.id}
                                jobCardDivParentRef={jobCardDivParentRef}
                              />
                            </div>
                          ))}
                      </div>
                      {allJobs?.results && (
                        <Pagination
                          pageSize={10}
                          current={currentPage}
                          total={allJobs?.count}
                          onChange={onCurrentPageChange}
                          style={{
                            bottom: "0px",
                            textAlign: "center",
                            marginTop: 20,
                          }}
                        />
                      )}
                    </Col>

                    <Col lg={7} xl={8} className="pl-0 pl-lg-3">
                      {jobDetailsLoading ? (
                        <div className="d-flex justify-content-center align-items-center w-100">
                          <Spinner animation="border" variant="primary" />
                        </div>
                      ) : (
                        <JobDetailsCard
                          jobDetails={jobDetails}
                          handleClose={handleClose}
                          onViewCompany={onViewCompany}
                          userMetaData={userMetaData}
                          onApplyClick={onApplyClick}
                          formSubmitError={formSubmitError}
                        />
                      )}
                    </Col>
                  </Row>
                )}
              </>
            )}
          </div>
        </Container>
        {userMetaData?.role === "candidate" ? (
          <CandidateJobApply
            jobDetails={jobDetails}
            fieldsShown={fieldsShown}
            userInfo={userInfo}
            onProfileUpdate={onProfileUpdate}
            formSubmitError={formSubmitError}
            onFormDataChange={onFormDataChange}
            formData={formData}
            onCoverLetterUpload={onCoverLetterUpload}
            handleClose={handleClose}
            onSubmitForm={onSubmitForm}
            jobApplyLoading={jobApplyLoading}
            onResumeUpload={onResumeUpload}
            editResumeClicked={editResumeClicked}
            onResumeEditClick={onResumeEditClick}
            onApplyClick={onApplyClick}
            jobApplyModal={jobApplyModal}
            isResumeLoading={isResumeLoading}
            isPrfoileUpdateLoading={isPrfoileUpdateLoading}
          />
        ) : (
          <MentorJobApply
            jobDetails={jobDetails}
            userInfo={userInfo}
            onProfileUpdate={onProfileUpdate}
            formSubmitError={formSubmitError}
            handleClose={handleClose}
            onSubmitForm={onSubmitForm}
            jobApplyLoading={jobApplyLoading}
            onResumeUpload={onResumeUpload}
            editResumeClicked={editResumeClicked}
            onResumeEditClick={onResumeEditClick}
            onApplyClick={onApplyClick}
            jobApplyModal={jobApplyModal}
            isResumeLoading={isResumeLoading}
            isPrfoileUpdateLoading={isPrfoileUpdateLoading}
          />
        )}
      </div>
    </MainLayout>
  );
}
export default JobListingExpanded;
